const matchExpression = (
  expression,
  cases = { default: 'Esse recurso não existe!' },
) => cases[expression] || cases?.default;
export default matchExpression;
